import styled from '@emotion/styled';
import {
  Button,
  SvgIcon,
  SvgNames,
  tokens,
  Typography,
} from '@sunrun/experience-ui-components';
import playbookImage from 'assets/images/Playbook.png';
import { getUrls } from 'helpers/getUrlHelper';
import { publishMessage } from 'helpers/messaging';
import { isStreetOrFusionHelper } from 'helpers/repTypeHelper';
import { useUserProfile } from 'providers/UserProfile';

const useShowPlaybook = () => {
  const { userProfile } = useUserProfile();
  if (!userProfile) {
    return false;
  }

  return isStreetOrFusionHelper(userProfile);
};

const PlaybookWidget = () => {
  const { oneBaseUrl } = getUrls();

  const handleOpenPlaybook = () => {
    publishMessage({
      source: 'Dashboard',
      type: 'COMMAND:CHANGE_URL',
      payload: {
        url: `${oneBaseUrl}/support/playbook`,
      },
    });
  };

  return (
    <Wrapper>
      <Card>
        <CardInfo>
          <Typography
            color={tokens.BRAND_HERO_BLUE}
            size={18}
            fontWeight="medium"
            lineHeight={21}>
            Playbook
          </Typography>
          <Typography
            size={14}
            color={tokens.TINTS_OFF_WHITE_20}
            lineHeight={20}>
            Review Playbook and add your own notes.
          </Typography>
        </CardInfo>
        <CardImage $image={playbookImage} />
        <GoButton onClick={handleOpenPlaybook}>
          <Typography color={tokens.WHITE} size={16}>
            Go to Playbook
          </Typography>
          <SvgIcon
            width={24}
            height={24}
            color="white"
            name={SvgNames.ExternalLink}
          />
        </GoButton>
      </Card>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 12px 12px;
  flex: 1;
  min-height: 0;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  flex: 1;
  min-height: 0;
  padding: 14px 16px;
  border: solid 1px ${tokens.TINTS_OFF_WHITE_40};
  border-radius: 16px;
  background-color: ${tokens.BRAND_OFF_WHITE};
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`;

const CardImage = styled.div<{ $image: string }>`
  flex: 1;
  min-height: 120px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${tokens.TINTS_OFF_WHITE_40};
  background-image: url(${({ $image }) => $image});
  background-repeat: no-repeat;
  background-position: top left;
  background-size: cover;
  box-sizing: border-box;
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  flex-shrink: 0;
`;

const GoButton = styled(Button)`
  width: 100%;
  line-height: 22px;
  padding: 8px 24px;
  font-weight: 400;
  flex-shrink: 0;

  & > span {
    display: flex;
    font-size: 16px;
    max-height: 24px;
    line-height: 24px;
    gap: 8px;
  }
`;

export { PlaybookWidget, useShowPlaybook };
